<template>
  <el-dialog
    :show-close="false"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <div class="dia-content">
      <!-- PC 端图片 -->
      <div class="img1 pc-img">
        <img class="left-back" src="@/assets/new/dialog.png" alt="" />
      </div>

      <!-- 移动端图片 -->
      <div class="img2 mobile-img">
        <img src="@/assets/new/yidong1.png" alt="" />
        <img src="@/assets/new/yidong2.png" alt="" />
      </div>

      <div class="dia-close" @click="handleClose">
        <img src="@/assets/new/shut.png" alt="" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    openLog() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep body {
  overflow: visible !important;
  padding-right: 0 !important;
}
::v-deep .el-popup-parent--hidden {
  padding-right: 0 !important;
  overflow: visible !important;
}
// 弹窗宽度自适应
::v-deep .el-dialog {
  width: 800px;
  margin: 0 auto;
  border-radius: 20px !important; /* 全局圆角20px */
  overflow: hidden !important;    /* 保证图片不会超出圆角 */
}
::v-deep .el-dialog__header {
  padding: 0;
}
::v-deep .el-dialog__body {
  padding: 0;
}

// 内容区
.dia-content {
  height: 500px;
  position: relative;
  background-color:transparent;
  .left-back {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    display: block;
  }
  .dia-close {
    cursor: pointer;
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 8px;
    z-index: 99;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

// 移动端图片容器
.img2 {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}
.pc-img {
  display: block;
}
.mobile-img {
  display: none;
}

/* 移动端：宽度＜768px 自动切换 */
@media (max-width: 768px) {
  ::v-deep .el-dialog {
    width: 90% !important;   /* 手机弹窗宽度90% */
  }
  .dia-content {
    height: auto;           /* 高度自适应 */
  }
  .pc-img {
    display: none;    /* 隐藏PC图 */
  }
  .mobile-img {
    display: block;   /* 显示手机图 */
  }
}
</style>
